const INSIGHTS_EVENT = 'INSIGHTS_EVENT'

export {
  INSIGHTS_EVENT
}
